import { styled } from '@mui/material';
import { JsonCopyToClipboardField } from 'shared/react-admin/Fields';

export const JsonCopyToClipboardFieldStyled = styled(JsonCopyToClipboardField)(({ theme }) => ({
  background: '#fff !important',
  border: `1px dotted ${theme.palette.action.disabled}`,
  maxWidth: '707px !important',
  height: '160px',
  overflow: 'auto',
  marginBottom: '12px',
}));
